module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/fast-truck-nudge-e5aa48a4bc87dd4d68f287e3251351a3.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/fast-truck-nudge.svg
// module id = iXMp
// module chunks = 24